var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSwiperLeftEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1485_8190)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 6,
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9263 31.0116L33.0352 37.0769C33.1691 37.2109 33.3284 37.3174 33.504 37.39C33.6796 37.4626 33.8679 37.5 34.0581 37.5C34.2483 37.5 34.4366 37.4626 34.6122 37.39C34.7878 37.3174 34.9471 37.2109 35.081 37.0769C35.3494 36.8088 35.5 36.4463 35.5 36.0684C35.5 35.6905 35.3494 35.3279 35.081 35.0599L29.9807 29.996L35.081 24.9321C35.3494 24.6641 35.5 24.3015 35.5 23.9236C35.5 23.5457 35.3494 23.1832 35.081 22.9151C34.9464 22.7826 34.7868 22.6777 34.6112 22.6065C34.4357 22.5353 34.2477 22.4992 34.0581 22.5003C33.8685 22.4992 33.6805 22.5353 33.505 22.6065C33.3294 22.6777 33.1698 22.7826 33.0352 22.9151L26.9263 28.9804C26.7913 29.1133 26.6841 29.2716 26.611 29.4459C26.5378 29.6202 26.5002 29.8072 26.5002 29.996C26.5002 30.1848 26.5378 30.3718 26.611 30.5461C26.6841 30.7204 26.7913 30.8787 26.9263 31.0116Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1485_8190",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1485_8190"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1485_8190",
    result: "effect2_dropShadow_1485_8190"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1485_8190",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSwiperLeftEnd);
export default __webpack_public_path__ + "static/media/ArrowSwiperLeftEnd.ad34dbdef22be8ba89957a046ff0ad47.svg";
export { ForwardRef as ReactComponent };